<template>
  <modal-box class="lottery-buy-tickets-modal" :title="'Buy Tickets'">
    <template #body>
      <div class="lottery-buy-tickets-modal__body">
        <div class="lottery-buy-tickets-modal__body__title">
          <p class="lottery-buy-tickets-modal__body__title__left">Buy:</p>
          <p class="lottery-buy-tickets-modal__body__title__right">Tickets</p>
        </div>

        <div class="lottery-buy-tickets-modal__body__input-section">
          <div class="lottery-buy-tickets-modal__body__input-section__quantity">
            <input
              type="number"
              v-model="quantity"
              min="0"
              :max="max"
              class="
                lottery-buy-tickets-modal__body__input-section__quantity__input
              "
            />
          </div>
          <div class="lottery-buy-tickets-modal__body__input-section__amount">
            <p
              class="
                lottery-buy-tickets-modal__body__input-section__amount__value
              "
            >
              ~{{ toFormattedToken(amount) }} {{ pool.type.toUpperCase() }}
            </p>
          </div>
        </div>

        <div class="lottery-buy-tickets-modal__body__balance">
          <p class="lottery-buy-tickets-modal__body__balance__value">
            {{ pool.type.toUpperCase() }} Balance:
            {{ toFormattedToken(account.balance) }}
          </p>
        </div>

        <div class="lottery-buy-tickets-modal__body__set-value-section">
          <button
            @click="setValue(3)"
            :disabled="max < 3"
            class="lottery-buy-tickets-modal__body__set-value-section__btn"
          >
            3
          </button>
          <button
            @click="setValue(9)"
            :disabled="max < 9"
            class="lottery-buy-tickets-modal__body__set-value-section__btn"
          >
            9
          </button>
          <button
            @click="setValue(18)"
            :disabled="max < 18"
            class="lottery-buy-tickets-modal__body__set-value-section__btn"
          >
            18
          </button>
          <button
            @click="setValue(max)"
            class="lottery-buy-tickets-modal__body__set-value-section__btn"
          >
            MAX
          </button>
        </div>

        <div class="lottery-buy-tickets-modal__body__detail">
          <div class="lottery-buy-tickets-modal__body__detail__cost">
            <p class="lottery-buy-tickets-modal__body__detail__cost__lable">
              Cost ({{ pool.type.toUpperCase() }})
            </p>
            <p class="lottery-buy-tickets-modal__body__detail__cost__value">
              {{ toFormattedToken(amount) }} {{ pool.type.toUpperCase() }}
            </p>
          </div>
          <div class="lottery-buy-tickets-modal__body__detail__discount">
            <p class="lottery-buy-tickets-modal__body__detail__discount__lable">
              <span
                class="
                  lottery-buy-tickets-modal__body__detail__discount__lable--big
                "
                >{{ totalDiscountPercent }}%</span
              >&nbsp;Bulk discount
            </p>
            <p class="lottery-buy-tickets-modal__body__detail__discount__value">
              {{ toFormattedToken(totalDiscountAmount) }}
              {{ pool.type.toUpperCase() }}
            </p>
          </div>
          <div class="lottery-buy-tickets-modal__body__detail__pay">
            <p class="lottery-buy-tickets-modal__body__detail__pay__lable">
              You pay
            </p>
            <p class="lottery-buy-tickets-modal__body__detail__pay__value">
              ~{{ toFormattedToken(totalCost) }} {{ pool.type.toUpperCase() }}
            </p>
          </div>
        </div>

        <div class="lottery-buy-tickets-modal__body__bottom">
          <div class="lottery-buy-tickets-modal__body__bottom__ctas">
            <input-button
              class="rounded-sm"
              :size="'large'"
              :is-loading="isLoading"
              :disabled="quantity <= 0 || quantity > max"
              @click="buy"
              >{{ isLoading ? "Buying" : "Buy Instantly" }}</input-button
            >
            <input-button
              :size="'large'"
              :type="'common'"
              :disabled="quantity == 0"
              @click="viewOrEditNumbers"
              class="
                lottery-buy-tickets-modal__body__bottom__ctas__view-edit
                rounded-sm
              "
              ><span
                class="
                  lottery-buy-tickets-modal__body__bottom__ctas__view-edit__text
                "
                >View/Edit Numbers</span
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="currentColor"
                class="
                  lottery-buy-tickets-modal__body__bottom__ctas__view-edit__icon
                "
              >
                <path
                  fill-rule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                /></svg
            ></input-button>
          </div>
          <div class="lottery-buy-tickets-modal__body__bottom__description">
            <p
              class="lottery-buy-tickets-modal__body__bottom__description__text"
            >
              “Buy Instantly” chooses random numbers, with no duplicates among
              your tickets. Prices are set before each round starts, equal to $5
              at that time. Purchases are final.
            </p>
          </div>
        </div>
      </div>
    </template>
  </modal-box>
</template>

<script>
import ModalBox from "@/components/molecules/ModalBox";
import InputButton from "@/components/atoms/InputButton";
import numFormat from "number-format.js";

export default {
  name: "LotteryBuyTicketsModal",
  components: {
    ModalBox,
    InputButton,
  },
  data() {
    return {
      isLoading: false,
      quantity: 1,
    };
  },
  computed: {
    max() {
      let a = parseInt(this.pool.ticketPrice);
      let b = -a * (parseInt(this.pool.discountDivisor) + 1);
      let c = this.account.balance * parseInt(this.pool.discountDivisor);
      let d = 4 * a * c;
      let e = Math.pow(b, 2);
      let delta = e - d;

      if (delta < 0) {
        return this.pool.maxNumberTicketsPerBuy;
      } else {
        return Math.floor((-b - Math.sqrt(delta)) / (2 * a));
      }
    },
    amount() {
      return this.quantity * parseInt(this.pool.ticketPrice);
    },
    totalCost() {
      return (
        (this.amount *
          (parseInt(this.pool.discountDivisor) + 1 - this.quantity)) /
        this.pool.discountDivisor
      );
    },
    totalDiscountPercent() {
      return parseInt(100 - (100 * this.totalCost) / this.amount);
    },
    totalDiscountAmount() {
      return this.amount - this.totalCost;
    },
    pool() {
      return this.$store.state.lotteries.pool;
    },
    web3() {
      return this.$store.state.web3;
    },
    account() {
      return this.$store.state.account;
    },
  },
  methods: {
    toFormattedToken(num) {
      return numFormat("#,##0.00000", num);
    },
    setValue(value) {
      this.quantity = value;
    },
    buy() {
      alert("buying");
    },
    viewOrEditNumbers() {
      this.$store.dispatch("openModal", "lottery-edit-numbers-modal");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.lottery-buy-tickets-modal {
  font-size: 1.6rem;
  font-weight: normal;

  &__body {
    margin-right: 18px;
    margin-left: 18px;

    &__title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 20px;

      &__left {
        font-size: 1.7rem;
        font-weight: 600;
      }
      &__right {
        font-size: 1.7rem;
        font-weight: 600;
      }
    }

    &__input-section {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      border-radius: 6px;
      padding: 5% 5%;
      margin-bottom: 20px;
      background-color: #f4f2fc;
      box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.16) inset;
      -webkit-box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.16) inset;
      -moz-box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.16) inset;

      &__quantity {
        &__input {
          outline: none;
          font-size: 2rem;
          text-align: right;
        }
      }

      &__amount {
        &__value {
          font-weight: 600;
        }
      }
    }

    &__balance {
      margin-bottom: 20px;
      &__value {
        text-align: right;
      }
    }

    &__set-value-section {
      display: flex;
      gap: 18px;
      margin-bottom: 20px;

      &__btn {
        display: block;
        text-align: center;
        text-decoration: none;
        cursor: pointer;
        border: none;
        width: 100%;
        transition: $transition-common;
        background: #f4f2fc;
        height: 32px;
        line-height: 32px;
        font-size: 1.3rem;
        border-radius: 16px;
        box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.16);
        -webkit-box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.16);
        -moz-box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.16);

        &:disabled {
          background: $color-disabled;
          cursor: not-allowed;
        }
      }
    }

    &__detail {
      &__cost {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 20px;

        &__lable {
        }
        &__value {
        }
      }

      &__discount {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        &__lable {
          &--big {
            font-size: 2rem;
            font-weight: 600;
          }
        }

        &__value {
        }
      }

      &__pay {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        border-top: 1px solid #e9eaeb;
        margin-bottom: 20px;

        &__lable {
        }

        &__value {
          font-size: 2rem;
          font-weight: 600;
        }
      }
    }
    &__bottom {
      &__ctas {
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-bottom: 20px;

        &__view-edit {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          gap: 10px;
          &__text {
          }
          &__icon {
          }
        }
      }

      &__description {
        &__text {
        }
      }
    }
  }

  .rounded-sm {
    border-radius: 8px;
  }
}
</style>
